import FooterPage from "../components/Custom/Footer/FooterPage";
import Navbar from "../components/Custom/Navbar/Navbar";
import TicketVerifier from "../components/Verifier/TicketVerifier";

export default function Verifier() {
  return (
    <>
      <Navbar />
      <TicketVerifier />
      <FooterPage />
    </>
  );
}
